<template>
  <section class="qrs-typography">
    <pageHeader>
      <h1 class="qrs-header-xl">Getting to know me</h1>
    </pageHeader>

    <p>Here you can record information about yourself and your life story.</p>

    <p>
      You can share this information with anyone you want, for example for
      example, new people you meet who might be giving you support such as home
      care workers, and staff in hospitals and dementia groups.
    </p>

    <p>
      There are a few questions for each heading. You don't need to answer all
      the questions if you don't want to.
    </p>

    <button
      name="get started"
      aria-label="get started with getting to know me"
      class="govuk-button mt--24"
      @click="$parent.goTo($MainLanding)"
    >
      Get Started
      <span class="screen-reader-text"
        >get started with getting to know me</span
      >
    </button>

    <hr class="divider" />

    <h3>Questions form</h3>
    <p class="mb--0">
      If you can't complete the questions form using the app then please
      download the form below to fill in the answers offline.
    </p>

    <button
      name="Download form"
      aria-label="Download questions form"
      class="govuk-button govuk-button--secondary mt--24"
    >
      Download form
      <span class="screen-reader-text">Download questions form</span>
    </button>
  </section>
</template>

<script>
export default {
  name: "intro",
};
</script>